(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["g20-bundle-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectors = document.querySelectorAll('[data-g20-bundle-selector]');

    selectors.forEach((selector) => {
      if (selector.dataset.initialized === 'true') return;
      selector.dataset.initialized = 'true';

      const section = selector.closest('.shopify-section') || document;
      const choices = Array.from(selector.querySelectorAll('[data-g20-bundle-choice]'));

      const quantityInputs = () => Array.from(section.querySelectorAll('input[name="quantity"]'));

      const selectQuantity = (quantity) => {
        choices.forEach((choice) => {
          const selected = Number(choice.dataset.quantity) === quantity;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        quantityInputs().forEach((input) => {
          input.value = String(quantity);
          input.setAttribute('value', String(quantity));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };

      selector.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-g20-bundle-choice]');
        if (!choice || !selector.contains(choice)) return;
        selectQuantity(Number(choice.dataset.quantity));
      });

      section.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="quantity"]')) return;
        const quantity = Number(event.target.value);
        choices.forEach((choice) => {
          const selected = Number(choice.dataset.quantity) === quantity;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });

      requestAnimationFrame(() => selectQuantity(1));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["g20-trust-payment"] && !Shopify.designMode) return;
  try {
    (() => {
    document.body.classList.add('g20-page-active');

    const trustBlocks = document.querySelectorAll('[data-g20-trust-payment]');

    trustBlocks.forEach((trustBlock) => {
      const section = trustBlock.closest('.shopify-section') || document;
      const originalAmazonLink = section.querySelector('a[href*="amazon.com"]:not(.g20-amazon-card__link)');
      const amazonCardLink = trustBlock.querySelector('.g20-amazon-card__link');
      const addButton = section.querySelector('#AddToCart, button[name="add"]');

      if (originalAmazonLink && amazonCardLink) {
        amazonCardLink.href = originalAmazonLink.href;
        originalAmazonLink.style.setProperty('display', 'none', 'important');
      }

      if (addButton) {
        addButton.classList.add('g20-primary-add');

        const updateAddButton = () => {
          const selectedBundle = section.querySelector('[data-g20-bundle-choice].is-selected');
          const selectedPrice = selectedBundle?.querySelector('.g20-bundle-selector__price strong')?.textContent?.trim();
          const label = addButton.querySelector('[data-text] span, [data-text]');

            if (label) label.textContent = 'Add to Cart';
        };

        updateAddButton();
        section.addEventListener('click', (event) => {
          if (!event.target.closest('[data-g20-bundle-choice]')) return;
          window.setTimeout(updateAddButton, 200);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
